export const SET_OFFERING = 'main/SET_OFFERING';
export const RESET_OFFERING = 'main/RESET_OFFERING';

export const setOffering = (offering, requestSessionUuid) => ({
  type: SET_OFFERING,
  offering,
  requestSessionUuid,
});

export const resetOffering = () => ({
  type: RESET_OFFERING,
});



// WEBPACK FOOTER //
// ./main/actions/offering-actions.js